"use strict";
//@ts-nocheck
/**
 * 关联交易基础配置
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
var bzMap = {
    "ZAR": "CNYZARC",
    "GBP": "GBPCNYC",
    "EUR": "EURCNYC",
    "KRW": "CNYKRWC",
    "RUB": "CNYRUBC",
    "MYR": "CNYMYRC",
    "CHF": "CHFCNYC",
    "NOK": "CNYNOKC",
    "AED": "CNYAEDC",
    "SAR": "CNYSARC",
    "AUD": "AUDCNYC",
    "THB": "CNYTHBC",
    "SGD": "SGDCNYC",
    "CAD": "CADCNYC",
    "HKD": "HKDCNYC",
    "USD": "USDCNYC",
    "JPY": "JPYCNYC",
    "MXN": "CNYMXNC",
    "SEK": "CNYSEKC",
    "DKK": "CNYDKKC",
    "TRY": "CNYTRYC"
};
var pageopt = {
    bzMap: bzMap,
    columns: {
        SECURITY_CODE: emfield.code,
        SECURITY_NAME_ABBR: emfield.name,
        xg: {
            formatter: function (value, item, i, field) {
                return "<a class=\"red\" href=\"/gljy/detail/" + item.SECURITY_CODE + ".html\">\u8BE6\u7EC6</a> <a href=\"/stockdata/" + item.SECURITY_CODE + ".html\">\u6570\u636E</a> \n                <a href=\"/notices/stock/" + item.SECURITY_CODE + ".html\">\u516C\u544A</a>";
            }
        },
        RELATED_PARTY: {
            formatter: function (value, item, i, field) {
                if (fieldtools_1["default"].isEmpty(item.TRADESECURITY_CODE)) {
                    return "<div class=\"popCla\" data-title=\"" + fieldtools_1["default"].escapeHTML(fieldtools_1["default"].strformat(value)) + "\">" + fieldtools_1["default"].cutstr(value, 28) + "</div>"; //交易方
                }
                else {
                    if (item.TRADESECURITY_CODE.length == 6) {
                        return "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(item.TRADESECURITY_CODE) + "\">" + item.TRADESECURITY_NAME_ABBR + "</a>";
                    }
                    else {
                        return fieldtools_1["default"].strformat(item.TRADESECURITY_NAME_ABBR);
                    }
                }
            }
        },
        RELATED_RELATION: emfield.string,
        TRADE_AMT: {
            formatter: function (value, item, i, field) {
                return fieldtools_1["default"].fieldfmt(value, { zoom: 4, num: 2 });
            }
        },
        CURRENCY_NAME: {
            formatter: function (value, item, i, field) {
                if (item.CURRENCY) {
                    return bzMap.hasOwnProperty(item.CURRENCY) ? "<a href=\"//quote.eastmoney.com/cnyrate/" + bzMap[item.CURRENCY] + ".html\">" + value + "</a>" : fieldtools_1["default"].strformat(value);
                }
                else {
                    return fieldtools_1["default"].strformat(value);
                }
            }
        },
        TRADE_PROFILE: emfield.title_15,
        TRADE_WAY: emfield.string,
        NETPROFIT: {
            formatter: function (value, item, i, field) {
                return fieldtools_1["default"].isEmpty(item.NETPROFIT) ? "-" : fieldtools_1["default"].fieldfmt(item.NETPROFIT, { num: 2 }) + "(" + fieldtools_1["default"].fieldfmt(item.DATE_TYPE_CODE, { num: 0 }) + ")";
            }
        },
        NOTICE_DATE: emfield.date,
        PAY_WAY: emfield.title_10,
        OPERATE_INCOME: {
            formatter: function (value, item, i, field) {
                return fieldtools_1["default"].isEmpty(item.OPERATE_INCOME) ? "-" : fieldtools_1["default"].fieldfmt(item.OPERATE_INCOME, { num: 2 }) + "(" + fieldtools_1["default"].fieldfmt(item.DATE_TYPE_CODE, { num: 0 }) + ")";
            }
        },
        xq_xg: {
            formatter: function (value, item, i, field) {
                return "<a class=\"red\" href=\"/gljy/stock/" + item.SECURITY_CODE + "-" + item.EID + ".html\">\u8BE6\u60C5</a> <a href=\"/notices/stock/" + item.SECURITY_CODE + ".html\">\u516C\u544A</a>";
            }
        }
    }
};
window.pageopt = pageopt;
exports["default"] = pageopt;
